import styled, { type DefaultTheme } from "styled-components";
import { Textarea } from "../../atoms/Textarea";
import { StoryKeyAreasSection } from "../StoryKeyAreasSection";
import {
  Field as ChipInputField,
  Input as ChipTextInput,
} from "../ChipInput/ChipInput.styles";
import {
  KeyAreaInput,
  KeyAreaText,
  SectionBody,
  SectionHeader,
  SectionTitle,
  SectionTitleGroup,
} from "../../organisms/StoryBuilder/StoryBuilder.styles";
import { typographyMixin } from "../../../design-system/tokens/typography";

const fieldLabelGap = ({ theme }: { theme: DefaultTheme }) =>
  `calc(${theme.spacing.base[1]} + ${theme.spacing.base[0.5]})`;

export const DetailsPanel = styled.section`
  display: flex;
  height: 100%;
  min-height: 0;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  gap: ${({ theme }) => theme.spacing.base[2]};
  padding: ${({ theme }) => theme.spacing.base[3]};
  border: ${({ theme }) => theme.borders.width[1]}
    ${({ theme }) => theme.borders.style.solid}
    ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${({ theme }) => theme.borders.radius.xl};
  background: ${({ theme }) => theme.colors.background.primary};

  ${ChipInputField} {
    min-height: ${({ theme }) => theme.spacing.base[10]};
    border-radius: ${({ theme }) => theme.borders.radius.lg};
  }

  ${ChipTextInput} {
    ${typographyMixin("caption", 3)}
  }
`;

export const DescriptionField = styled(Textarea)`
  gap: ${fieldLabelGap};

  textarea {
    height: calc(
      ${({ theme }) => theme.spacing.base[20]} +
        ${({ theme }) => theme.spacing.base[2]}
    );
    resize: none;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: ${fieldLabelGap};
`;

export const FieldLabel = styled.label`
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const FieldError = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.error.text};
`;

export const KeyQuestionsSection = styled(StoryKeyAreasSection)`
  gap: ${fieldLabelGap};
  padding: 0;
  border-radius: 0;
  background: ${({ theme }) => theme.colors.background.primary};

  > ${SectionHeader},
  > ${SectionBody} {
    padding-right: 0;
    padding-left: 0;
  }

  ${SectionTitleGroup} > svg {
    display: none;
  }

  ${SectionTitle} {
    ${typographyMixin("caption", 3)}
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  ${KeyAreaText},
  ${KeyAreaInput} {
    ${typographyMixin("caption", 3)}
  }

  ${KeyAreaInput} {
    padding: ${({ theme }) => theme.spacing.base[2]}
      ${({ theme }) => theme.spacing.base[3]};
  }
`;
